import { render } from "./LogoKn.vue?vue&type=template&id=3d5db088&scoped=true&ts=true"
import script from "./LogoKn.vue?vue&type=script&lang=ts"
export * from "./LogoKn.vue?vue&type=script&lang=ts"

import "./LogoKn.vue?vue&type=style&index=0&id=3d5db088&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5db088"]])

export default __exports__